import React, { Component } from "react";
import { withFirebase } from "../../config";
import { Button } from "semantic-ui-react";
import { Redirect } from "react-router-dom";

/*Navbar*/
import OuterHeader from "../Layout/OuterHeader";
import Dashboard from "../Dashboard";
import InnerHeader from "../Layout/InnerHeader";
import NavBar from "../Layout/NavBar";
import Footer from "../Layout/Footer";
/*Redux */
import "firebase/firestore";
import "firebase/auth";
import { connect } from "react-redux";
import propTypes from "prop-types";
/*Actions */
import { saveSeries } from "../../Actions/SeriesActions";
import { emptyError } from "../../Actions/Empty";
import { fetchAllSeries } from "../../Actions/SeriesActions";
/*Component */
import PublishDate from "../Layout/PublishDate";
import UploadImage from "../S3Uploading/UploadImage";
import UploadAudio from "../S3Uploading/UploadAudio";
import UploadVideo from "../S3Uploading/UploadVideo";

/*CSS */
import "../../css/AppCss/Series/AddSeries.css";
/* Routes */
import { ALL_SERIES } from "../../routes";
import { clearPreSignData, clearAll } from "../../Actions/VideoCipherActions";
import IntroWithMusicUploader from "../FilePondUploading/IntroWithMusicUploader";
import IntroWithoutMusicUploader from "../FilePondUploading/IntroWithoutMusicUploader";
import PromoWithMusicUploader from "../FilePondUploading/PromoWithMusicUploader";
import PromoWithoutMusicUploader from "../FilePondUploading/PromoWithoutMusicUploader";
import { SERIES_FOLDER_NAME_WITH_MUSIC, SERIES_FOLDER_NAME_WITH_OUT_MUSIC } from "../../portal/src/constants";

const INITIAL_STATE = {
  /////////// Series
  name: "",
  description: "",
  nameInEnglish: "",
  descriptionInEnglish: "",
  publish_date: "",
  error: "",
  imgURL: "",
  audio: "",
  promo_with_music: "",
  promo_without_music: "",
  intro_with_music: "",
  intro_without_music: "",
  videoKeyIntroWithMusic: "",
  videoKeyIntroWithoutMusic: "",
  videoKeyPromoWithMusic: "",
  videoKeyPromoWithoutMusic: "",
  error: true,
  errorMessage: "",
  featured: false,
  ageFrom: '',
  ageTo: '',
};

class AddSeries extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  handleUploadIntroWithMusic = (uploadInfo) => {

    if (
      uploadInfo &&
      uploadInfo !== undefined &&
      uploadInfo !== null &&
      Object.keys(uploadInfo).length > 0
    ) {
      this.setState({ videoKeyIntroWithMusic: uploadInfo.videoId });
    } else {
      this.setState({ videoKeyIntroWithMusic: "" });
    }
  };
  handleUploadIntroWithoutMusic = (uploadInfo) => {

    if (
      uploadInfo &&
      uploadInfo !== undefined &&
      uploadInfo !== null &&
      Object.keys(uploadInfo).length > 0
    ) {
      this.setState({ videoKeyIntroWithoutMusic: uploadInfo.videoId });
    } else {
      this.setState({ videoKeyIntroWithoutMusic: "" });
    }
  };
  handleUploadPromoWithMusic = (uploadInfo) => {

    if (
      uploadInfo &&
      uploadInfo !== undefined &&
      uploadInfo !== null &&
      Object.keys(uploadInfo).length > 0
    ) {
      this.setState({ videoKeyPromoWithMusic: uploadInfo.videoId });
    } else {
      this.setState({ videoKeyPromoWithMusic: "" });
    }
  };
  handleUploadPromoWithoutMusic = (uploadInfo) => {

    if (
      uploadInfo &&
      uploadInfo !== undefined &&
      uploadInfo !== null &&
      Object.keys(uploadInfo).length > 0
    ) {
      this.setState({
        videoKeyPromoWithoutMusic: uploadInfo.videoId,
      });
    } else {
      this.setState({ videoKeyPromoWithoutMusic: "" });
    }
  };
  saveSeries(
    name,
    description,
    imgURL,
    publish_date,
    audio,
    promo_with_music,
    promo_without_music,
    intro_with_music,
    intro_without_music,
    nameInEnglish,
    descriptionInEnglish,
    videoKeyIntroWithMusic,
    videoKeyIntroWithoutMusic,
    videoKeyPromoWithMusic,
    videoKeyPromoWithoutMusic,
    featured,
    ageFrom,
    ageTo
  ) {

    // let introWithMusicVideoId = this.props.vdocipherUploadInfo.IntroWithMusic
    //   ? this.props.vdocipherUploadInfo.IntroWithMusic.videoId
    //   : "";
    // let introWithoutMusicVideoId = this.props.vdocipherUploadInfo
    //   .IntroWithoutMusic
    //   ? this.props.vdocipherUploadInfo.IntroWithoutMusic.videoId
    //   : "";
    // let promoWithMusicVideoId = this.props.vdocipherUploadInfo.PromoWithMusic
    //   ? this.props.vdocipherUploadInfo.PromoWithMusic.videoId
    //   : "";
    // let promoWithoutMusicVideoId = this.props.vdocipherUploadInfo
    //   .PromoWithoutMusic
    //   ? this.props.vdocipherUploadInfo.PromoWithoutMusic.videoId
    //   : "";
    this.props.saveSeries(
      name,
      description,
      imgURL,
      publish_date,
      audio,
      promo_with_music,
      promo_without_music,
      intro_with_music,
      intro_without_music,
      nameInEnglish,
      descriptionInEnglish,
      videoKeyIntroWithMusic,
      videoKeyIntroWithoutMusic,
      videoKeyPromoWithMusic,
      videoKeyPromoWithoutMusic,
      featured,
      ageFrom,
      ageTo
    );
  }

  getPublishDate(publishDateTime) {
    if (publishDateTime) {
      this.setState({ publish_date: publishDateTime });

    }
  }

  getImageUrl(imageUrl) {
    if (imageUrl === "delete") {
      this.setState({
        imgURL: "",
        error: true,
        errorMessage: "Empty Data is not accepted",
      });
    } else if (imageUrl !== undefined || imageUrl !== "") {
      this.setState({ imgURL: imageUrl });
      if (
        this.state.name !== "" &&
        this.state.name !== " " &&
        this.state.name !== null
      ) {
        this.setState({ error: false, errorMessage: "" });
      }
    } else {
      this.setState({
        imgURL: "",
        error: true,
        errorMessage: "Empty Data is not accepted",
      });
    }
  }

  getPromoWithMusicVideoUrl(videoUrl) {
    if (videoUrl !== "delete") {
      this.setState({ promo_with_music: videoUrl });


    } else {
      this.setState({ promo_with_music: "" });
    }
  }

  getPromoWithoutMusicVideoUrl(videoUrl) {
    if (videoUrl !== "delete") {
      this.setState({ promo_without_music: videoUrl });


    } else {
      this.setState({ promo_without_music: "" });
    }
  }

  getIntroWithoutMusicVideoUrl(videoUrl) {
    if (videoUrl !== "delete") {
      this.setState({ intro_without_music: videoUrl });


    } else {
      this.setState({ intro_without_music: "" });
    }
  }

  getIntroWithMusicVideoUrl(videoUrl) {
    if (videoUrl !== "delete") {
      this.setState({ intro_with_music: videoUrl });


    } else {
      this.setState({ intro_with_music: "" });
    }
  }

  handleChange = (e) => {
    let checkSpaces = e.target.value.replace(/\s\s+/g, " ");
    const specialCharacters = /[@#$%^&*()\+={}[\]:;<>,\/|\\]/; 
    this.setState({ [e.target.name]: checkSpaces });
    let nameOfState = e.target.name;
    setTimeout(() => {
      if (specialCharacters.test(this.state.name) || specialCharacters.test(this.state.nameInEnglish)){
        this.setState({
          error: true,
          errorMessage: "Series name can't contain spaecial characters",
        });
      }
      else if (
        this.state.imgURL === "" ||
        this.state.imgURL === null ||
        this.state.imgURL === undefined ||
        this.state.name === "" ||
        this.state.name === null ||
        this.state.name === " " ||
        this.state.descriptionInEnglish.length > 255
      ) {
        this.setState({
          error: true,
          errorMessage:
            nameOfState === "descriptionInEnglish"
              ? "Description in English is too long (greater than 255 characters)."
              : "Empty Data is not accepted",
        });
      } 
      else if (
        (this.state.imgURL !== "" || this.state.imgURL !== undefined) &&
        (this.state.name !== null ||
          this.state.name !== "" ||
          this.state.name !== " ") &&
        this.state.descriptionInEnglish.length <= 255
      ) {
        this.setState({ error: false, errorMessage: "" });
      } 
    
      
      else {
        this.setState({
          error: true,
          errorMessage: "Empty Data is not accepted",
        });
      }
    }, 0);
  };

  handleCheckboxChange = () => {
    this.setState({ featured: !this.state.featured })
  };

  handleSubmit = (e) => {
    const {
      name,
      description,
      publish_date,
      imgURL,
      audio,
      promo_with_music,
      promo_without_music,
      intro_with_music,
      intro_without_music,
      nameInEnglish,
      descriptionInEnglish,
      videoKeyIntroWithMusic,
      videoKeyIntroWithoutMusic,
      videoKeyPromoWithMusic,
      videoKeyPromoWithoutMusic,
      featured,
      ageFrom,
      ageTo
    } = this.state;


    if (e.nativeEvent.submitter.id === "saveButton") {
      // Validate age range
      if (ageFrom && ageTo && ageFrom !== '' && ageTo !== '') {
        const fromAge = parseInt(ageFrom);
        const toAge = parseInt(ageTo);
        if (!isNaN(fromAge) && !isNaN(toAge) && toAge < fromAge) {
          alert("Age To must be greater than or equal to Age From");
          e.preventDefault();
          return;
        }
      }

      this.saveSeries(
        name,
        description,
        imgURL,
        publish_date,
        audio,
        promo_with_music,
        promo_without_music,
        intro_with_music,
        intro_without_music,
        nameInEnglish,
        descriptionInEnglish,
        videoKeyIntroWithMusic,
        videoKeyIntroWithoutMusic,
        videoKeyPromoWithMusic,
        videoKeyPromoWithoutMusic,
        featured,
        ageFrom,
        ageTo
      );
    }
    // this.closeModal();
    e.preventDefault();
  };

  getAudio(audioUrl) {
    // get  Audio
    if (audioUrl) {
      // check if url =  delete send empty to DB
      if (audioUrl === "delete") {
        this.setState({ audio: "" });

      }
      // else send the url to DB
      else {
        this.setState({ audio: audioUrl });

      }
    }
  }

  render() {
    const { name, image, error } = this.state;

    const { seriesError } = this.props;
    const { seriesSuccess } = this.props;

    const isInvalidSeries = name === "" || image === "";

    const { loading } = this.props;
    let $buttonSubmitLoader = (
      <Button disabled={this.state.error} id="saveButton">
        Add
      </Button>
    );

    if (loading === true) {
      $buttonSubmitLoader = (
        <button id="saveButton" class="ui loading button">
          Loading
        </button>
      );
    }

    if (seriesSuccess === false) {

      alert("error missing data or network " + seriesError);
      this.props.emptyError();
      this.props.clearAll();
    } else if (seriesSuccess === true) {

      alert("Series added Successfully");
      this.props.emptyError();
      this.props.fetchAllSeries();
      this.props.clearAll();

      this.setState({
        name: "",
        status: "",
        publish_date: "",
        imgURL: "",
        audio: "",
        promo_with_music: "",
        promo_without_music: "",
        intro_with_music: "",
        intro_without_music: "",
        nameInEnglish: "",
        videoKeyIntroWithMusic: "",
        videoKeyIntroWithoutMusic: "",
        videoKeyPromoWithMusic: "",
        videoKeyPromoWithoutMusic: "",
      });

      return <Redirect to={ALL_SERIES}></Redirect>;
    }

    return (
      <div className="container">
        <OuterHeader />
        <div className="container">
          <div className="container-body">
            <div className="row">
              <Dashboard />
              <div className="col">
                <InnerHeader />
                <div className="main-content">
                  <div className="row">
                    <div className="col-12 left-main-body" id="left-main-body">
                      <NavBar />
                      <br />
                      <div className="container">
                        <h3>Add New Series</h3>
                        <hr />

                        <div className="">
                          <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row">
                              {/* image Uploader */}
                              <div className="col-md-4 col-12">
                                <div className="">
                                  <span className="required_input">*</span>
                                  <UploadImage
                                    getImageURLCallBack={this.getImageUrl.bind(
                                      this
                                    )}
                                    imageUrl={this.state.imgURL}
                                    imagepreview={this.state.imgURL}
                                    s3DirectryrName="series"
                                  />
                                </div>
                              </div>

                              <div className="col-md-8 col-12">
                                <p style={{ color: "red" }}>
                                  {this.state.errorMessage}{" "}
                                </p>
                                <label htmlFor="name" className="label">
                                  <span className="required_input">*</span>
                                  Name
                                </label>
                                <input
                                  dir="auto"
                                  className="form-control"
                                  fluid
                                  name="name"
                                  id="name"
                                  onChange={this.handleChange}
                                  value={this.state.name}
                                />

                                <br />

                                <label
                                  htmlFor="nameInEnglish"
                                  className="label"
                                >
                                  {/* <span className="required_input">*</span> */}
                                  Name In English
                                </label>
                                <input
                                  dir="auto"
                                  className="form-control"
                                  fluid
                                  name="nameInEnglish"
                                  id="nameInEnglish"
                                  onChange={this.handleChange}
                                  value={this.state.nameInEnglish}
                                />
                                <br />

                                <div className="form-group">
                                  <label
                                    htmlFor="description"
                                    className="label"
                                  >
                                    Description
                                  </label>

                                  <textarea
                                    dir="auto"
                                    fluid
                                    rows="3"
                                    className="form-control"
                                    name="description"
                                    id="description"
                                    onChange={this.handleChange}
                                    value={this.state.description}
                                  />
                                </div>
                                <br />

                                <div className="form-group">
                                  <label
                                    htmlFor="descriptionInEnglish"
                                    className="label"
                                  >
                                    Description In English
                                  </label>

                                  <textarea
                                    dir="auto"
                                    fluid
                                    rows="3"
                                    className="form-control"
                                    name="descriptionInEnglish"
                                    id="descriptionInEnglish"
                                    onChange={this.handleChange}
                                    value={this.state.descriptionInEnglish}
                                  />
                                </div>
                                <br />

                                <label htmlFor="name" className="label">
                                  Audio
                                </label>

                                <UploadAudio
                                  getAudioUrlCallBack={this.getAudio.bind(this)}
                                  audioPreview={this.state.audio}
                                  audioUrl={this.state.audio}
                                  s3DirectryrName="series/audio"
                                />

                                {/* DateComponent */}
                                <PublishDate
                                  getPublishDateCallBack={this.getPublishDate.bind(
                                    this
                                  )}
                                  value={this.state.publish_date}
                                />
                                <br />
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={this.state.featured}
                                    onChange={this.handleCheckboxChange}
                                  />
                                  {' Featured'}
                                </label>

                                <br />
                                
                                <div className="form-inline">
                                  <div className="col" style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                    <label htmlFor="ageFrom" className="label">
                                      Age From
                                    </label>
                                    <br />
                                    <input
                                      dir="auto"
                                      className="form-control"
                                      type="number"
                                      min="0"
                                      name="ageFrom"
                                      id="ageFrom"
                                      onChange={this.handleChange}
                                      value={this.state.ageFrom || ''}
                                      fluid
                                    />
                                  </div>
                                  <div className="col" style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                    <label htmlFor="ageTo" className="label">
                                      Age To
                                    </label>
                                    <br />
                                    <input
                                      dir="auto"
                                      className="form-control"
                                      type="number"
                                      min={this.state.ageFrom && this.state.ageFrom !== '' ? parseInt(this.state.ageFrom) : 0}
                                      name="ageTo"
                                      id="ageTo"
                                      onChange={this.handleChange}
                                      value={this.state.ageTo || ''}
                                      fluid
                                    />
                                  </div>
                                </div>
                                <br />

                                <br />
                              </div>
                            </div>

                            {error && <p>{error.message}</p>}

                            <label className="label">Intro With Music</label>
                            <div>
                              <IntroWithMusicUploader
                                id="IntroWithMusic"
                                onUploadInfo={this.handleUploadIntroWithMusic}
                                folderName={SERIES_FOLDER_NAME_WITH_MUSIC}
                              />
                            </div>
                            <br />
                            <label className="label">Intro Without Music</label>
                            <div>
                              <IntroWithoutMusicUploader
                                id="IntroWithoutMusic"
                                onUploadInfo={
                                  this.handleUploadIntroWithoutMusic
                                }
                                folderName={SERIES_FOLDER_NAME_WITH_OUT_MUSIC}
                              />
                            </div>
                            <br />
                            <label className="label">Promo With Music</label>
                            <div>
                              <PromoWithMusicUploader
                                id="PromoWithMusic"
                                onUploadInfo={this.handleUploadPromoWithMusic}
                                folderName={SERIES_FOLDER_NAME_WITH_MUSIC}
                              />
                            </div>
                            <br />
                            <label className="label">Promo Without Music</label>
                            <div>
                              <PromoWithoutMusicUploader
                                id="PromoWithoutMusic"
                                onUploadInfo={
                                  this.handleUploadPromoWithoutMusic
                                }
                                folderName={SERIES_FOLDER_NAME_WITH_OUT_MUSIC}
                              />
                            </div>
                            <br />

                            {/* <label className="label">Intro with music</label>
                            <div>
                              <UploadVideo
                                getVideoURLCallBack={this.getIntroWithMusicVideoUrl.bind(
                                  this
                                )}
                                videoPreview={this.state.intro_with_music}
                                videoUrl={this.state.intro_with_music}
                                s3DirectryrName="series"
                              />
                            </div>
                            <br />

                            <label className="label">Intro without music</label>
                            <div>
                              <UploadVideo
                                getVideoURLCallBack={this.getIntroWithoutMusicVideoUrl.bind(
                                  this
                                )}
                                videoPreview={this.state.intro_without_music}
                                videoUrl={this.state.intro_without_music}
                                s3DirectryrName="series"
                              />
                            </div>
                            <br />

                            <label className="label">Promo with music</label>
                            <div>
                              <UploadVideo
                                getVideoURLCallBack={this.getPromoWithMusicVideoUrl.bind(
                                  this
                                )}
                                videoPreview={this.state.promo_with_music}
                                videoUrl={this.state.promo_with_music}
                                s3DirectryrName="series"
                              />
                            </div>
                            <br />

                            <label className="label">Promo without music</label>
                            <div>
                              <UploadVideo
                                getVideoURLCallBack={this.getPromoWithoutMusicVideoUrl.bind(
                                  this
                                )}
                                videoPreview={this.state.promo_without_music}
                                videoUrl={this.state.promo_without_music}
                                s3DirectryrName="series"
                              />
                            </div>
                            <br /> */}

                            <div className="input-field">
                              {$buttonSubmitLoader}

                              {/* <Button  id="cancelButton">
                                                        Cancel
                                                        </Button> */}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
AddSeries.propTypes = {
  saveSeries: propTypes.func.isRequired,
  fetchAllSeries: propTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  loading: state.series.loading,

  series: state.series.items,
  seriesError: state.series.error_adding_series,
  seriesSuccess: state.series.series_added_sucessfully,
  // vdocipherUploadInfo: state.vdoCipher.entity,
});

export default withFirebase(
  connect(mapStateToProps, {
    saveSeries,
    emptyError,
    fetchAllSeries,
    clearPreSignData,
    clearAll,
  })(AddSeries)
);
